import React from 'react';
import MediaQuery from 'react-responsive';
import { subscribe } from 'react-contextual';
import { Row, Col} from 'reactstrap';
import onClickHandle from '../onClickHandle';

const getImages = (margin, imageProps) => {
	let classCol = margin == true ? 'gi-location-card default d-flex justify-content-center ' : 'gi-location-card no-padding d-flex justify-content-center ';
	if (imageProps.length > 2) {
		const stackClass = `stack-${imageProps.length}`;
		classCol += stackClass;
	}
	return (
		imageProps.map((item, index) => (
			<Col className={classCol} key={index}>
				<a href={item.link} onClick={(e) => onClickHandle(e, 'location-panel-click', { index, location: item.location }, item.link)} >
					<MediaQuery query="(max-width: 576px)">
						<Row className="d-flex align-self-center py-3" style={{ margin: '0 auto !important' }}>
							<img className="grid-image align-self-center location-panel" src={item.imageMobile} alt={item[index]} />
							<Col sm="12" xs="12">
								<p className="main-heading">{item.location}</p>
								<p className="sub-heading">{item.subHeading}</p>
							</Col>
						</Row>
					</MediaQuery>
					<MediaQuery query="(min-width: 576px)">
						<Row className="d-flex align-self-center py-3 h-100">
							<img className="grid-image align-self-center location-panel" src={item.image} alt={item[index]} />
							<Col sm="12" xs="12">
								<p className="main-heading">{item.location}</p>
								<p className="sub-heading">{item.subHeading}</p>
							</Col>
						</Row>
					</MediaQuery>
				</a>
			</Col>))
	);
};

const LocationBlock = ({
	className, style, margin, imageProps
}) => (
	<Row className="d-flex remove-margin justify-content-center">
		{getImages(margin, imageProps)}
	</Row>
);

LocationBlock.defaultProps = {
	margin: true,
	title: 'empower women to fight back',
	className: 'd-flex justify-content-center location-panel',
	imageProps: [
		{
			image: '/static/images/delhi.png',
			imageMobile: '/static/images/delhi.png',
			location: 'Delhi',
			subHeading: '52 programs',
			link: '/search?tag=New%20Delhi&type=relevance',
		},
		{
			image: '/static/images/maharashtra.png',
			imageMobile: '/static/images/maharashtra.png',
			location: 'Maharashtra',
			subHeading: '52 programs',
			link: '/search?tag=Maharashtra&type=relevance',
		},
		{
			image: '/static/images/karnataka.png',
			imageMobile: '/static/images/karnataka.png',
			location: 'Karnataka',
			subHeading: '52 programs',
			link: '/search?tag=Karnataka&type=relevance',
		},
		{
			image: '/static/images/odisha.png',
			imageMobile: '/static/images/odisha.png',
			location: 'Odisha',
			subHeading: '152 programs',
			link: '/search?tag=Odisha&type=relevance',
		},
		{
			image: '/static/images/rajasthan.png',
			imageMobile: '/static/images/rajasthan.png',
			location: 'Rajasthan',
			subHeading: '52 programs',
			link: '/search?tag=Rajasthan&type=relevance',
		},
	],
};

export default subscribe()(LocationBlock);
